import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useUserContext } from '@spacefill/shared/src/utils/contexts/UserContext';

function buildUrl(baseUrl, path) {
    const fullUrl = `//${window.location.host}${baseUrl}`;

    if (fullUrl.indexOf('/external-console/') >= 0) {
        return `${fullUrl.replace('external-console', 'admin-console')}${path}`;
    } else if (fullUrl.indexOf('app.spacefill.fr') >= 0) {
        return `${fullUrl.replace('app.spacefill.fr', 'admin.app.spacefill.fr')}${path}`;
    } else if (fullUrl.indexOf('app.staging.spacefill.fr') >= 0) {
        return `${fullUrl.replace('app.staging.spacefill.fr', 'admin.app.staging.spacefill.fr')}${path}`;
    } else if (fullUrl.indexOf('localhost') >= 0) {
        return `${fullUrl.replace(/:\d+/, ':1240')}${path}`;
    }
}

export const AdminLinks = () => {
    const { user } = useUserContext();
    return (
        <div>
            <div className='text-xs'>Admin links</div>

            {user.customerId && (
                <a
                    href={buildUrl(__ROUTER_BASE_NAME__, `customers/${user.customerId}/settings/`)}
                    target='_blank'
                    rel='noreferrer'
                    className='flex items-center text-sm gap-2'
                >
                    Customer settings{' '}
                    <FontAwesomeIcon
                        icon={faArrowUpRightFromSquare}
                        className='text-xs'
                    />
                </a>
            )}
            {user.logisticProviderId && (
                <a
                    href={buildUrl(__ROUTER_BASE_NAME__, `logistic-providers/${user.logisticProviderId}/settings/`)}
                    target='_blank'
                    rel='noreferrer'
                    className='flex items-center text-sm gap-2'
                >
                    Provider settings{' '}
                    <FontAwesomeIcon
                        icon={faArrowUpRightFromSquare}
                        className='text-xs'
                    />
                </a>
            )}
        </div>
    );
};
